import { lazy } from "react"

const ContributionListPage$$__react__lazy__component = lazy(() => 
    import("./ContributionListPage__original__module.mjs")
        .then(module => module.get_$$ContributionListPage$$ContributionListPage$$react__component$$1ru6jz46xeu8o())
        .then(component => ({ default: component }))
)

export const get_$$ContributionListPage$$ContributionListPage$$react__component$$1ru6jz46xeu8o = () => ContributionListPage$$__react__lazy__component